document.addEventListener('DOMContentLoaded', function(){

  if (document.querySelectorAll('.js-false-select-label').length > 0) {
    document.removeEventListener('click', handleFalseSelectLabelClick);
    document.addEventListener('click', handleFalseSelectLabelClick);
  }
  

  let totalProductSections = document.querySelectorAll('.landing-product-revamp .product-section');
  
  if(totalProductSections.length){
    
    totalProductSections.forEach((section) => {
      let productVariantSlector = section.querySelectorAll('.variant-wrapper.js .variant-input input');

      //add active class to current selected input value to main image
      if (section.querySelectorAll('.product-variant-images .variant-images').length > 0) {
        if (productVariantSlector.length > 0) {
          productVariantSlector.forEach((input) => {
            if (input.checked == true) {
              let foundActiveMain = false;
              section.querySelectorAll('.product-variant-images .variant-images').forEach((imgwrap) => {
                if (foundActiveMain == false && imgwrap.dataset.value.split('/')[0].trim() == input.value) {
                  imgwrap.classList.add('active');
                  foundActiveMain = true;
                }
              });
            }
          });
        }
      }

      //add active class to current selected input value to thumb image
      if (section.querySelectorAll('.product-variant-images .variant-images2').length > 0) {
        //input
        if (productVariantSlector.length > 0) {
          productVariantSlector.forEach((input) => {
            if (input.checked == true) {
              let foundActiveThumb = false;
              section.querySelectorAll('.product-variant-images .variant-images2').forEach((imgwrap) => {
                if (foundActiveThumb == false && imgwrap.dataset.value.split('/')[0].trim() == input.value) {
                  imgwrap.classList.add('active');
                  foundActiveThumb = true;
                }
              });
            }
          });
        }
      }      

      gallarySlider(section);

      //handleKachingBundleSelectChange(section)
    });

    //handle style product click event
    let styleProductEle = document.querySelectorAll('.landing-product-revamp .product-section [data-style-product]');
    if(styleProductEle.length){
      styleProductEle.forEach(link => {
        link.addEventListener('click', function(e){
          e.preventDefault();
          let getId = e.target.getAttribute('data-id');
          if(getId){
            totalProductSections.forEach(section => section.classList.add('hide'));
            styleProductEle.forEach(ele => ele.classList.remove('active'));
            document.querySelector(`.landing-product-revamp .product-section[data-product-id="${getId}"] .landing-product__link[data-id="${getId}"]`).classList.add('active');
            document.querySelector(`.landing-product-revamp .product-section[data-product-id="${getId}"]`).classList.remove('hide');
          }
        });        
      });
    }

    //default selected tab if url have ?selected_item param.
    let styleProductEleTab = document.querySelectorAll('.landing-product-revamp .product-section [data-style-product]');
    if(styleProductEleTab.length){
      let serchParam = window.location.search;
      if(serchParam.includes('?selected_item')){
        let getProdId = serchParam.replace('?selected_item=','');
        document.querySelector(`.landing-product-revamp .product-section .landing-product__link--img[data-id="${getProdId}"]`).click();
      }
    }
    
  }

  document.addEventListener('variant:change', function(evt) {
    const op1 = evt.detail.variant.option1, op2 = evt.detail.variant.option2, op3 = evt.detail.variant.option3;
    const current_product_id = evt.detail.product_id;
    console.log('variant:change >>',evt.detail.variant, 'product_id >>',current_product_id);
    
    if(current_product_id){

      //change the selected variant label
      const selected_variant_label = document.querySelectorAll(`.product-section[data-product-id="${current_product_id}"] .variant-wrapper .varian-name-label`);
      if(selected_variant_label.length){
        if(selected_variant_label[0] && op1) selected_variant_label[0].textContent = op1;
        if(selected_variant_label[1] && op2) selected_variant_label[1].textContent = op2;
        if(selected_variant_label[2] && op3) selected_variant_label[2].textContent = op3;
      }

      //change dropdown false label
      const falseSelectLabels = document.querySelectorAll(`.product-section[data-product-id="${current_product_id}"] .variant-wrapper .js-false-select-label`);
      if(falseSelectLabels.length){
        if(falseSelectLabels[0] && op1) falseSelectLabels[0].textContent = op1;
        if(falseSelectLabels[1] && op2) falseSelectLabels[1].textContent = op2;
        if(falseSelectLabels[2] && op3) falseSelectLabels[2].textContent = op3;
      }

      //remove active class
      const variant_dropdown_el = document.querySelectorAll(`.product-section[data-product-id="${current_product_id}"] .variant-wrapper .custom-select-input`);
      if(variant_dropdown_el.length){
        variant_dropdown_el.forEach(el => el.classList.remove('active'));
      }

      //show variant specific images
      const variant_main_images = document.querySelectorAll(`.product-section[data-product-id="${current_product_id}"] .product-variant-images .variant-images`);
      if(variant_main_images.length){
        variant_main_images.forEach((imgwrap) => {
          if (imgwrap.dataset.value.split('/')[0].trim() == op1 || imgwrap.dataset.value.split('/')[0].trim() == op2) {
            variant_main_images.forEach(imwrpgwrap => imwrpgwrap.classList.remove('active'));
            imgwrap.classList.add('active');
            gallarySlider(document.querySelector(`.product-section[data-product-id="${current_product_id}"]`));
          }
        });
      }
      const variant_thumb_images = document.querySelectorAll(`.product-section[data-product-id="${current_product_id}"] .product-variant-images .variant-images2`);
      if(variant_thumb_images.length){
        variant_thumb_images.forEach((imgwrap) => {
          if (imgwrap.dataset.value.split('/')[0].trim() == op1 || imgwrap.dataset.value.split('/')[0].trim() == op2) {
            variant_thumb_images.forEach(imwrpgwrap => imwrpgwrap.classList.remove('active'));
            imgwrap.classList.add('active');
            gallarySlider(document.querySelector(`.product-section[data-product-id="${current_product_id}"]`));
          }
        });
      }
      
    }
  });
  
});


function gallarySlider(section) {

  let slider_ele = document.querySelector('.product-variant-images .land-slider-top.active');
  let thumb_ele = document.querySelector('.product-variant-images .slider__thumbs.active');
  
  if(section){
    thumb_ele = section.querySelector('.product-variant-images .slider__thumbs.active');
    slider_ele = section.querySelector('.product-variant-images .land-slider-top.active');
  }
  
  const sliderThumbs = new Swiper(thumb_ele, {
    direction: 'horizontal',
    slidesPerView: 6,
    spaceBetween: 15,
    navigation: {
      nextEl: '.slider__next',
      prevEl: '.slider__prev'
    },
    freeMode: true,
    breakpoints: {
      0: {
        direction: 'horizontal',
        slidesPerView: 5
      }
    }
  });

  const sliderImages = new Swiper(slider_ele, {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 0,
    mousewheel: true,
    grabCursor: true,
    thumbs: {
      swiper: sliderThumbs
    }
  });
  
}

function handleFalseSelectLabelClick(event) {
  const falseSelectLabels = document.querySelectorAll('.js-false-select-label');

  falseSelectLabels.forEach(falseSelectLabel => {
    const parentElement = falseSelectLabel.parentElement;

    if (event.target === falseSelectLabel) {
      parentElement.classList.toggle('active');
    } else if (!parentElement.contains(event.target)) {
      parentElement.classList.remove('active');
    }
  });
}

function handleKachingBundleSelectChange(section){
  const observer = new MutationObserver(function(mutationsList) {
  for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const quantityBreaksWrapper = addedNodes.find(node => node.classList && node.classList.contains('kaching-bundles__bars'));
    
        if (quantityBreaksWrapper && quantityBreaksWrapper.childElementCount !== 0) {
          const kachingVariants = section.querySelectorAll('.kaching-bundles__bar-variant-select');
          const kachingVariantsColors = section.querySelectorAll('.kaching-bundles__bar-variant-select:first-child');
          
          if (kachingVariants) {
            kachingCustomize(kachingVariants,section);

            kachingVariantsColors.forEach(v => {
              v.addEventListener('change', (e) => {
                const kachOptions = e.target.parentElement.querySelectorAll('option');
                if (kachOptions) {
                  kachOptions.forEach(kachOption => {
                    kachOption.style.display = 'block';
                    kachOption.disabled = false;
                  });
                  const productTitle = section.querySelector('.product-single__meta .product__main__title');
                  if (productTitle) {
                    const allOptions = Array.from(section.querySelector(`[data-prodtitle="${productTitle.textContent}"]`).querySelectorAll(`[data-color="${e.target.value}"]`));
                    const kachSelect = e.target.parentElement.querySelector('select:not(:first-child)');
                    const kachAllOptions = kachSelect.querySelectorAll('option');
                    let activeTrigger = 0;

                    kachAllOptions.forEach(kachOption => {
                      if (!(hasTextInDiv(kachOption.textContent, allOptions))) {
                        kachOption.style.display = 'none';
                        kachOption.disabled = true;
                      } else if (activeTrigger === 0) {
                        setTimeout(() => {
                          kachSelect.value = kachOption.textContent;
                          kachOption.selected = true;
                          kachSelect.dispatchEvent(new Event('change'))
                        }, 0);
                        activeTrigger += 1;
                      }
                    });
                  }
                }
              });
            })
          }
        }
      }
    }
  });
  const config = { childList: true, subtree: true };
  observer.observe(document, config);
}

function kachingCustomize(kachingVariants,section) {
  const kachOptions = section.querySelectorAll('.kaching-bundles__bar-variant-select option');
  const disabledVariants = section.querySelectorAll('.variant-input input.disabled');

  if (disabledVariants && kachOptions) {
    kachOptions.forEach(kachOption => {
      kachOption.style.display = 'block';
      kachOption.disabled = false;
    });
    
    disabledVariants.forEach(themeVariant => {
      kachingVariants.forEach(kachingVariant => {
        kachOptions.forEach(kachOption => {
          if (kachOption.value === themeVariant.value) {
            kachOption.style.display = 'none';
            kachOption.disabled = true;
          }
        })
      })
    });
  }

}

function hasTextInDiv(text, divs) {
  for (let div of divs) {
    if (div.textContent.trim() === text.trim()) {
      return true;
    }
  }
  return false;
}
